export interface Operation {
  name: string;
  period?: string;
  description: string;
  images?: string[];
  additionalInfo?: string;
  driveLink?: string;
}

export const interpolOperations: Operation[] = [
  {
    name: "OPERASI SEAF (SOUTHEAST AND EAST ASIA FUGITIVES)",
    period: "2023-2026",
    description:
      "Project Operasi INTERPOL dengan jangka 3 tahun sejak 2023-2026 yang disponsori oleh Korea Selatan dengan tujuan untuk memberikan wadah kepada negara-negara SEAF (Indonesia, Malaysia, Thailand, Singapura, Vietnam, Filipina, Kamboja, Australia, China, Hong Kong, Jepang, dan Korea Selatan) untuk melakukan kerjasama bilateral dan multilateral dalam pertukaran informasi khususnya dalam penanganan buronan dengan melakukan analisis, dan pencarian untuk mengidentifikasi pergerakan, Modus Operandi serta mengidentifikasi lokasi subyek sehingga dapat dilakukan penangkapan.",
    images: [
      "/operasi-interpol/image1.jpeg",
      "/operasi-interpol/image2.jpeg",
      "/operasi-interpol/image3.jpeg",
      "/operasi-interpol/image4.jpeg",
      "/operasi-interpol/image5.jpeg",
    ],
  },
  {
    name: "OPERASI PANGEA",
    period: "Sejak 2008",
    description:
      "Operasi global INTERPOL tahunan sejak tahun 2008 dengan tujuan utama untuk memberantas peredaran obat dan produk kesehatan ilegal atau palsu yang dijual secara daring. Operasi ini sangat penting karena melindungi masyarakat dari ancaman serius terhadap kesehatan yang disebabkan oleh obat-obatan palsu, yang sering kali mengandung bahan berbahaya atau tidak memiliki kandungan zat aktif sama sekali. Selain itu, perdagangan farmasi ilegal juga merupakan sumber utama pendanaan bagi kelompok kejahatan terorganisir lintas negara. Operasi ini melibatkan kerja sama lintas sektor antara aparat penegak hukum, otoritas kesehatan, bea cukai, regulator obat, serta platform e-commerce dan perusahaan pembayaran dari berbagai negara.",
  },
  {
    name: "OPERASI LIONFISH",
    period: "Sejak 2013",
    description:
      "Operasi global INTERPOL sejak tahun 2013 yang bertujuan untuk memberantas jaringan perdagangan narkotika lintas negara melalui jalur udara, laut, dan darat. Operasi ini melibatkan kerja sama antara negara-negara di kawasan Asia, Afrika, Timur Tengah, dan Amerika Latin, dengan dukungan lembaga penegak hukum, bea cukai, otoritas pelabuhan, serta organisasi internasional seperti UNODC dan WCO. Dalam pelaksanaannya, Operasi Lionfish memanfaatkan platform intelijen INTERPOL seperti I-RAID dan RELIEF untuk mendeteksi serta memetakan jalur distribusi narkoba dan prekursor kimia yang digunakan dalam pembuatan narkotika sintetis. Operasi ini mengungkap hubungan erat antara perdagangan narkoba dan kejahatan terorganisir lainnya seperti penyelundupan senjata, pencucian uang, dan terorisme.",
    images: [
      "/operasi-interpol/image6.jpeg",
      "/operasi-interpol/image7.jpeg",
      "/operasi-interpol/image8.jpeg",
      "/operasi-interpol/image9.jpeg",
      "/operasi-interpol/image10.jpeg",
    ],
  },
  {
    name: "OPERASI HAECHI",
    period: "Sejak 2020",
    description:
      "Operasi global INTERPOL yang didukung oleh Korea Selatan sejak tahun 2020 untuk memerangi kejahatan finansial siber seperti penipuan investasi, romance scam, voice phishing, sextortion, bisnis email compromise, perjudian online ilegal, dan e-commerce fraud. Dengan dukungan sistem pengendalian keuangan cepat seperti IGRIP dan ARRP, serta penerbitan Purple Notice untuk modus baru, Operasi HAECHI telah berhasil menghentikan arus dana kriminal lintas negara dan memperkuat kerja sama internasional dalam menghadapi kejahatan siber finansial.",
  },
  {
    name: "OPERASI SECURE",
    description:
      "Operasi global INTERPOL di bawah Asia and South Pacific Joint Operations Against Cybercrime (ASPJOC) yang berfokus pada penghentian aktivitas infrastruktur malware pencuri data (infostealer), dengan sasaran utama berupa server dan domain yang digunakan untuk mencuri informasi pribadi—seperti kredensial browser, rincian kartu kredit, dan data dompet kripto—yang kemudian masuk ke pasar gelap atau menjadi pintu masuk ke serangan ransomware dan penipuan finansial. Dari operasi ini berhasil menghapus lebih dari 20.000 alamat IP dan domain berbahaya, menyita 41 server, serta mengamankan lebih dari 100 GB data teknis terkait infrastuktur kriminal.",
    images: [
      "/operasi-interpol/image11.jpeg",
      "/operasi-interpol/image12.jpeg",
      "/operasi-interpol/image13.jpeg",
      "/operasi-interpol/image14.jpeg",
    ],
  },
  {
    name: "OPERASI MAHARLIKA",
    period: "Sejak 2017",
    description:
      "Operasi INTERPOL yang merupakan bagian dari project CT-SEA(Counter Terrorism – Southeast Asia) khusus untuk wilayah Asia Tenggara sejak tahun 2017 yang didukung oleh pemerintah Jepang dan bertujuan memperkuat pengawasan perbatasan dan menekan aktivitas terorisme serta kejahatan lintas negara seperti perdagangan manusia dan penyelundupan senjata. Operasi ini mengandalkan layanan biometrik INTERPOL dan pertukaran intelijen realtime untuk mendeteksi dan menahan pergerakan tersangka teroris dan orang asing berisiko tinggi.",
    driveLink:
      "https://drive.google.com/drive/folders/1e0zvAFueaBjOEKHJKLLQ7f01mWOD6tEs?usp=sharing",
    additionalInfo: "DOKUMENTASI MAHARLIKA 4",
  },
  {
    name: "OPERASI JACKAL",
    period: "Sejak 2022",
    description:
      "Operasi global INTERPOL sejak tahun 2022 dengan tujuan utama menindak jaringan kejahatan keuangan daring yang berbasis di Afrika Barat—terutama geng kriminal seperti Black Axe. operasi ini berhasil melemahkan infrastruktur keuangan kriminal, memblokir aset, dan mempersempit ruang gerak pelaku kejahatan siber.",
    images: [
      "/operasi-interpol/image15.jpeg",
      "/operasi-interpol/image16.jpeg",
    ],
  },
  {
    name: "OPERASI LIBERTERRA",
    period: "Sejak 2021",
    description:
      "Operasi global INTERPOL sejak tahun 2021 untuk memerangi perdagangan manusia dan penyelundupan migran. Operasi ini menunjukkan betapa luas dan terkorganisirnya jaringan trafficking antarnegara, sekaligus mempertegas efektivitas kolaborasi global dalam menentang kejahatan lintas negara tersebut.",
    images: [
      "/operasi-interpol/image17.jpeg",
      "/operasi-interpol/image18.jpeg",
      "/operasi-interpol/image19.jpeg",
      "/operasi-interpol/image20.jpeg",
    ],
  },
  {
    name: "OPERASI THUNDER",
    period: "Sejak 2017",
    description:
      "Operasi gabungan antara INTERPOL–WCO sejak tahun 2017 dengan melibatkan 138 negara yang fokus pada pemberantasan perdagangan satwa dan tumbuhan dilindungi secara ilegal.",
  },
  {
    name: "OPERASI STORMMAKERS",
    period: "Sejak 2022",
    description:
      "Operasi INTERPOL sejak tahun 2022 yang bertujuan menindak jaringan penyelundupan manusia dan perdagangan manusia, termasuk praktek penipuan siber yang memanfaatkan korban migran. Operasi ini menegaskan bahwa kejahatan perdagangan manusia kini semakin terhubung dengan penipuan siber, memanfaatkan korban bukan hanya sebagai sumber tenaga kerja ilegal, tetapi juga sebagai instrumen untuk melakukan kejahatan finansial global. Dari Operasi ini terkuak modus operandi yang digunakan antara lain penggunaan iklan kerja palsu untuk mengerahkan orang ke pusat scam daring, di mana mereka dipaksa melakukan penipuan melalui investasi kripto palsu, lotre, dan perjudian online, serta sering dieksploitasi secara fisik.",
    images: [
      "/operasi-interpol/image21.jpeg",
      "/operasi-interpol/image22.jpeg",
    ],
  },
];
